<template>
    <span>
        <span v-for="(part,idx) of parts" :key="idx" :class="part.class">{{ part.word }}</span>
    </span>
</template>
<script>
    /**
        This component will highlight supplied search terms
    */
    export default {
        props: {
            word: {
                type: String,
                required: true,
            },
            search: {
                type: String,
                required: true,
            },
        },

        computed: {
            parts() {
                if (this.search != "" && this.search.length > 2) {
                    const parts = [];

                    let start = 0;
                    let previous = 0;
                    while (start !== -1) {
                        start = this.word.toLowerCase().indexOf(this.search.toLowerCase(), start);
                        const word = this.word.substr(previous, (start > -1) ? start : this.word.length);
                        parts.push({word: word, class: ""});

                        if (start > -1) {
                            parts.push( {word: this.word.substr(start, this.search.length), class:"highlight"})
                            start += this.search.length;
                            previous = start;
                        }
                    }

                    return parts;
                }

                return [{ word: this.word, class: ""}]
            },
        },
    }
</script>
<style lang="scss" scoped>
    .highlight {
        background-color: rgba(0,200,250, 0.3);
        font-weight: 500;
    }
</style>
